<template>
    <div
        ref="scrollWrapper"
        class="d-flex align-center"
        style="overflow-x: hidden; background: #fff005; white-space: nowrap"
        @mouseenter="stopScrolling"
        @mouseleave="startScrolling"
    >
        <div
            ref="scrollContent"
            class="d-flex"
            :style="{
                transform: `translateX(${scrollX}px)`,
                transition: 'transform 0s linear',
            }"
        >
            <div
                v-for="(item, index) in loopedStats"
                :key="index"
                class="px-4 text-center"
                style="min-width: 300px"
            >
                <div style="font-weight: bold">{{ item.value }}</div>
                <span>{{ item.label }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import emitter from "@/eventBus";
import { showAlertModal } from "@/utils";

export default {
    name: "StatsBanner",
    data() {
        return {
            stats: [],
            scrollX: 0,
            animationFrame: null,
            scrollSpeed: 0.5,
        };
    },
    computed: {
        loopedStats() {
            return [...this.stats, ...this.stats];
        },
    },
    async created() {
        await this.fetchStats();
    },
    mounted() {
        this.fetchStats();
        this.startScrolling();
        emitter.on("language-changed", this.fetchStats);
    },
    beforeUnmount() {
        this.stopScrolling();
        emitter.off("language-changed", this.fetchStats);
    },
    methods: {
        showAlertModal,
        async fetchStats() {
            try {
                const response = await axios.get(
                    `${process.env.VUE_APP_API_URL}/realtime-stats/`
                );
                const data = response.data;

                this.stats = [
                    {
                        value: data.truck_last_24h,
                        label: this.$t("bannerStats.trucks24h"),
                    },
                    {
                        value: data.ware_last_24h,
                        label: this.$t("bannerStats.wares24h"),
                    },
                    {
                        value: data.active_users,
                        label: this.$t("bannerStats.totalUsers"),
                    },
                    {
                        value: data.available_trucks,
                        label: this.$t("bannerStats.totalTrucks"),
                    },
                    {
                        value: data.available_wares,
                        label: this.$t("bannerStats.totalWares"),
                    },
                ];
            } catch (error) {
                console.error("Failed to fetch real-time stats:", error);
            }
        },
        scrollLoop() {
            const content = this.$refs.scrollContent;
            const wrapper = this.$refs.scrollWrapper;

            this.scrollX -= this.scrollSpeed;
            const totalWidth = content.scrollWidth / 2;

            // Reset when the first full block is fully scrolled out
            if (Math.abs(this.scrollX) >= totalWidth) {
                this.scrollX = 0;
            }

            this.animationFrame = requestAnimationFrame(this.scrollLoop);
        },
        startScrolling() {
            if (!this.animationFrame) {
                this.animationFrame = requestAnimationFrame(this.scrollLoop);
            }
        },
        stopScrolling() {
            cancelAnimationFrame(this.animationFrame);
            this.animationFrame = null;
        },
    },
};
</script>
